import * as d3 from 'd3';
import { observable, action } from 'mobx';
import helpers from './util/helpers';
import { locale } from './Locale.js';

export const Api : ApiStateType = observable({
  domain: 'https://ikids-admin.reportback.org/api/v1',
  auth: {
    access_token: "",
    client: "",
    uid: "",
    expiry: ""
  },
  authenticate: action('authenticate', function(access_code) {
    const formData = new FormData();
    formData.append('access_code', access_code.toUpperCase());

    const params = {
      method: 'POST',
      body: formData
    };

    const promise = fetch(this.domain + '/auth/sign_in', params).then((response) => {
      ///window.localStorage.setItem('access_code', access_code.toUpperCase());
      this._set_headers(response,4);
      return response.json();
    })

    return promise;
  }),

  getURL: action('get', function(target) {
    //no-cors because chrome gets confused with 204 results that do not return the "Access-Control-Allow-Origin" header
    const myHeaders = this._get_headers('getURL');
    // console.log("getURL "+target + "\nmyHeaders="+JSON.stringify(myHeaders)); //XXX
    const promise = fetch(target, { headers: myHeaders }); //mode: "no-cors",

    promise.then((response) => {
        this._set_headers(response,3); // this won't be useful since csv/json files do not return a token. only sign_in does
        if (response.status === 401) {
            let thehash = window.location.hash;
            // console.log("getURL error at "+thehash+"=>"+target);
            if (thehash != "#/" && thehash != "#/login") {
              this.props.history.push("/login");
              window.scrollTo(0, 0);
            }
        }
      }
    );

    return promise;
    }
  ),

  get: action('get', function(target) {
    const myHeaders = this._get_headers('get');
    // console.log("get "+target + "\nmyHeaders="+JSON.stringify(myHeaders)); //XXX
    const promise = fetch(this.domain + target, { headers: myHeaders });

    promise.then((response) => {
      this._set_headers(response,3); // this won't be useful since csv/json files do not return a token. only sign_in does
    });

    return promise;
  }),

  postURL: action('post', function(target, formData) {
    const promise = fetch(target, { headers: this._get_headers(), method: 'POST', body: formData });

    promise.then((response) => {
      this._set_headers(response,2);
    });

    return promise;
  }),

  post: action('post', function(target, formData) {
    const promise = fetch(this.domain + target, { headers: this._get_headers(), method: 'POST', body: formData });

    promise.then((response) => {
      this._set_headers(response,2);
    });

    return promise;
  }),

  json: action('json', function(target) {
    return this.get(target).then((response) => response.json())
  }),

  csv: action('csv', function(target) {
    return this.get(target)
      .then((response) => response.text())
      .then((text) => d3.csvParse(text))
  }),

  logout: action('logout', function() {
    ///this.auth.access_code = "";
    this.auth.access_token = "";
    this.auth.client = "";
    this.auth.uid = "";
    this.auth.expiry = "";

    ///window.localStorage.setItem('access_code', '');
    window.localStorage.setItem('access-token', '');
    window.localStorage.setItem('client', '');
    window.localStorage.setItem('uid', '');
    window.localStorage.setItem('expiry', '');
  })
  ,
  _get_headers: function(name) {
    // console.log("_get_headers")
    if(this.auth.access_token !== "") {
      let result = {
        'access-token': this.auth.access_token,
        'token-type': 'Bearer',
        'client': this.auth.client,
        'uid': this.auth.uid,
        'expiry': this.auth.expiry
      }
      //console.log("_get_headers: " + name + "=>" + JSON.stringify(result));
      return result;
    }
    else if(window.localStorage.getItem('access-token') !== "") {
      return {
        'access-token': window.localStorage.getItem('access-token'),
        'token-type': 'Bearer',
        'client': window.localStorage.getItem('client'),
        'uid': window.localStorage.getItem('uid'),
        'expiry': window.localStorage.getItem('expiry')
      }
    }
    else
    {
      //
      // send via GET args (XXX kinda works but doesn't authenticate because probably can tell we are spoofing when we try via firefox when logged in on chrome)
      //
      //1/2--normally chosen via user, so set them here via get params
      //if (helpers.findGetParameter('language')) {
      //  window.localStorage.setItem('language', helpers.findGetParameter('language'));
      //  window.localStorage.setItem('avatar', helpers.findGetParameter('avatar'));
      //}
      //
      //2/2--for PDF printing service... send args here via get parameters
      return {
        'access-token': helpers.findGetParameter('access-token'),
        'token-type': 'Bearer',
        'client': helpers.findGetParameter('client'),
        'uid': helpers.findGetParameter('uid'),
        'expiry': helpers.findGetParameter('expiry')
      }

    } // end-else

  } // end _get_headers
  ,

  _set_headers: function(response,num)
  {
    // console.log("_set_headers "+num);
    // console.log("access-token=" + response.headers.get('access-token'));

    if(response.headers.get('access-token') !== null && response.headers.get('access-token') !== '')
    {
      this.auth.access_token = response.headers.get('access-token');
      this.auth.client = response.headers.get('client');
      this.auth.uid = response.headers.get('uid');
      this.auth.expiry = response.headers.get('expiry');

      window.localStorage.setItem('access-token', response.headers.get('access-token'));
      window.localStorage.setItem('client', response.headers.get('client'));
      window.localStorage.setItem('uid', response.headers.get('uid'));
      window.localStorage.setItem('expiry', response.headers.get('expiry'));
    }
  } // end _set_headers
,
  authenticateshell: function(get_access_code, stateobj)
  {
    return Api.authenticate(get_access_code).then((response) => {
      // console.log("API RESPONSE");
      // console.log(response);
      if(response.success === false) {
        //this.setState({ error: true })
      }
      else {
        // this.props.history.push('/avatar');
        stateobj.loadMeasurements();
        stateobj.loadHeadlines();
      }
    }); // end-then
  } // end-authenticateshell

});



// WEBPACK FOOTER //
// ./src/Api.js